<template>
    <div class="back-to-top" id="back-to-top" @click="scrollAction()"><span class="icon-arrow-right-swiper"></span>
    </div>
</template>

<script>
    import ScrollMagicGE from '../libs/ScrollMagicGE';
    import Scrolling from '../libs/Scrolling'

    export default {
        methods: {
            scrollAction() {
                Scrolling.scrollTo('body', 'easeInOutCubic', 1200)
                ScrollMagicGE.backToTopLeave()
            }
        },
        mounted() {
            ScrollMagicGE.backToTop()
        },
    }
</script>


// WEBPACK FOOTER //
// assets/js/components/BackToTop.vue